import { createContext } from "react";
import { emptyVehicle, IVehicle } from "../../../../types/vehicle.type";

type InitialStateType = {
  vehicle: IVehicle;
  updateVehicleState: (updatedData: Partial<IVehicle>) => void;
};

export const initialState: InitialStateType = {
  vehicle: emptyVehicle(),
  updateVehicleState: () => {},
};
export const VehicleDashboardContext = createContext(initialState);
